import React, { Component } from "react";
import "../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import "../css/planImageGallery.css";
import ImageGallery from 'react-image-gallery';

class PlanImageGallery extends Component {


    render() {
        return (
            <div style={{justifyContent:"center",alignItems:"center"}}>
                <ImageGallery
                    showIndex
                    showThumbnails={false}
                    showNav={false}
                    showPlayButton={false}
                    showFullscreenButton={false}
                    startIndex={this.props.index}
                    items={this.props.images}
                />
            </div>
        );
    }

}

export default PlanImageGallery;